import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";

import BlueLogo from "../layout/Employers/BlueLogo";

const SetupEmployerUsers = ({ auth: { user, isAuthenticated } }) => {
  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <div className="setup-container">
        <div className="initialize-title">
          <div className="flex">
            <div className="logo-setup">
              <BlueLogo />
            </div>
            <h1 className="setup-heading blue">Network with ime Users</h1>
          </div>
          <p className="lead">
            Connect with users similar to company name on ime
          </p>
        </div>
        <div className="setup-container">
          <div className="section-info">
            <p className="setup-info">See users below:</p>
            <Link to="/employerprofile">
              <p className="setup-next white">
                Next <i className="fas fa-arrow-circle-right blue mx-5"></i>
              </p>
            </Link>
          </div>
          <section className="friends-section">
            <div className="user-section-name">
              <i className="fas fa-users fa-lg mr-10 blue"></i>
              <p className="section-name">Employers</p>
            </div>
            <div className="friend-results">
              <div className="user-section border-blue">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border blue">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">Employer Name</li>
                    <li className="friend-info-item">Recruiter Name</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-plus mx-5"></i>
                        Casual
                      </button>
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-blue">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border blue">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">Employer Name</li>
                    <li className="friend-info-item">Recruiter Name</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-plus mx-5"></i>
                        Casual
                      </button>
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-blue">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border blue">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">Employer Name</li>
                    <li className="friend-info-item">Recruiter Name</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-plus mx-5"></i>
                        Casual
                      </button>
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-blue">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border blue">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">Employer Name</li>
                    <li className="friend-info-item">Recruiter Name</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-plus mx-5"></i>
                        Casual
                      </button>
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-blue">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border blue">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">Employer Name</li>
                    <li className="friend-info-item">Recruiter Name</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-plus mx-5"></i>
                        Casual
                      </button>
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-blue">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border blue">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">Employer Name</li>
                    <li className="friend-info-item">Recruiter Name</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-plus mx-5"></i>
                        Casual
                      </button>
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-blue">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border blue">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">Employer Name</li>
                    <li className="friend-info-item">Recruiter Name</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-plus mx-5"></i>
                        Casual
                      </button>
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="friends-section">
            <div className="user-section-name">
              <i className="fas fa-users fa-lg mr-10 blue"></i>
              <p className="section-name">Companies</p>
            </div>
            <div className="friend-results">
              <div className="user-section border-blue">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border blue">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">Employer Name</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-blue">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border blue">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">Employer Name</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-blue">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border blue">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">Employer Name</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-blue">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border blue">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">Employer Name</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-blue">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border blue">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">Employer Name</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-blue">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border blue">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">Employer Name</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-blue">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border blue">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">Employer Name</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-blue">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="friends-section">
            <div className="user-section-name">
              <i className="fas fa-users fa-lg mr-10 red"></i>
              <p className="section-name">Mentors</p>
            </div>
            <div className="friend-results">
              <div className="user-section border-red">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border red">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">User Name</li>
                    <li className="friend-info-item">Job Title</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-red">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-red">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border red">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">User Name</li>
                    <li className="friend-info-item">Job Title</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-red">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-red">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border red">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">User Name</li>
                    <li className="friend-info-item">Job Title</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-red">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-red">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border red">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">User Name</li>
                    <li className="friend-info-item">Job Title</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-red">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-red">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border red">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">User Name</li>
                    <li className="friend-info-item">Job Title</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-red">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-red">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border red">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">User Name</li>
                    <li className="friend-info-item">Job Title</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-red">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user-section border-red">
                <div className="users-container">
                  <div className="friend-user-avi-container">
                    <div className="avi-color-border red">
                      <div className="friend-user-avi"></div>
                    </div>
                  </div>
                  <div className="friend-user-info">
                    <li className="friend-info-item">User Name</li>
                    <li className="friend-info-item">Job Title</li>
                    <li className="friend-info-item">Location</li>
                  </div>
                  <div className="friends-buttons-container">
                    <div className="friend-button-container">
                      <button className="friend-button background-red">
                        <i className="fas fa-user-check mx-5"></i>
                        Follow
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(SetupEmployerUsers);
